import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../presentation/core/contexts/AuthContext";

export type PreventAuthProps = {
  children?: React.ReactElement;
};

export function PreventAuth({ children }: PreventAuthProps) {
  const { isSigned } = useAuth();
  const location = useLocation();

  if (isSigned && !location.pathname.includes("senha-aprovar")) {
    return <Navigate replace to="/" state={{ from: location }} />;
  }

  return children || <Outlet />;
}
